import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
	PassCollectionTitleDirective,
	PassCollectionHeaderActionDirective,
	PassCollectionContentDirective,
	PassCollectionEmptyStateDirective,
	PassCollectionV2Component,
} from './pass-collection-v2/pass-collection-v2.component';

@NgModule({
	declarations: [
		PassCollectionTitleDirective,
		PassCollectionHeaderActionDirective,
		PassCollectionContentDirective,
		PassCollectionEmptyStateDirective,
		PassCollectionV2Component,
	],
	imports: [CommonModule],
	exports: [
		PassCollectionTitleDirective,
		PassCollectionHeaderActionDirective,
		PassCollectionContentDirective,
		PassCollectionEmptyStateDirective,
		PassCollectionV2Component,
	],
})
export class PassCollectionV2Module {}
